<template>
  <div class="error-panel">
    <div class="error-panel__icon-wrap" v-if="showIcon">
      <i :class="[iconClass, 'error-panel__icon']"></i>
    </div>
    <h3 class="error-panel__text">
      <slot>{{ message }}</slot>
    </h3>
    <div class="error-panel__actions" v-if="showBack || $slots.actions">
      <slot name="actions">
        <el-button
          v-if="showBack"
          type="primary"
          :icon="backIcon"
          @click="handleBack"
        >
          {{ backText }}
        </el-button>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorPanel',
  props: {
    message: {
      type: String,
      default: '',
    },
    iconClass: {
      type: String,
      default: 'el-icon-warning-outline',
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    showBack: {
      type: Boolean,
      default: false,
    },
    backText: {
      type: String,
      default: '返回上一页',
    },
    backIcon: {
      type: String,
      default: 'el-icon-arrow-left',
    },
  },
  methods: {
    handleBack () {
      if (this.$router && this.$router.back) {
        this.$router.back()
      } else if (window && window.history) {
        window.history.back()
      }
    },
  },
}
</script>

<style scoped lang="scss">
.error-panel {
  padding: 40px 20px;
  min-height: 260px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;

  &__icon-wrap {
    margin-bottom: 20px;
  }

  &__icon {
    font-size: 64px;
    color: #F56C6C;
  }

  &__text {
    font-size: 20px;
    font-weight: 500;
    color: #303133;
    margin: 0 0 20px 0;
    max-width: 520px;
    line-height: 1.6;
    word-break: break-all;
  }

  &__actions {
    display: flex;
    justify-content: center;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/ErrorPanel.vue